import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbCollapseModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent, SdvorRadioComponent, SdvorSelectModule, TodayTomorrowDatePipeModule } from '@sdvor/shared/ui';
import { UrlModule } from '@spartacus/core';
import { FormErrorsComponent, IconModule } from '@spartacus/storefront';
import { SdvorManagerWillCallComponent } from './time-slot-list/manager-will-call/manager-will-call.component';
import { SdvorTimeSlotDatepickerModalComponent } from './time-slot-list/time-slot-datepicker-modal/time-slot-datepicker-modal.component';
import { TimeSlotsMinimalPrice } from './time-slot-list/time-slot-groups/minimal-price.pipe';
import { NextNHours } from './time-slot-list/time-slot-groups/next-n-hours.pipe';
import { SdvorTimeSlotGroupsInfoComponent } from './time-slot-list/time-slot-groups/time-slot-groups-info/time-slot-groups-info.component';
import { SdvorTimeSlotGroupsSelectComponent } from './time-slot-list/time-slot-groups/time-slot-groups-select/time-slot-groups-select.component';
import { SdvorTimeSlotGroupsTabComponent } from './time-slot-list/time-slot-groups/time-slot-groups-tab/time-slot-groups-tab.component';
import { SdvorTimeSlotGroupsComponent } from './time-slot-list/time-slot-groups/time-slot-groups.component';
import { SdvorTimeSlotListComponent } from './time-slot-list/time-slot-list.component';

@NgModule({
  imports: [
    NgIf,
    NgFor,
    AsyncPipe,
    NgClass,
    NgbCollapseModule,
    UrlModule,
    IconModule,
    ReactiveFormsModule,
    FormErrorsComponent,
    TodayTomorrowDatePipeModule,
    ModalComponent,
    NgbDatepickerModule,
    SdvorRadioComponent,
    SdvorSelectModule,
  ],
  declarations: [
    SdvorTimeSlotListComponent,
    SdvorTimeSlotDatepickerModalComponent,
    SdvorManagerWillCallComponent,
    SdvorTimeSlotGroupsComponent,
    SdvorTimeSlotGroupsSelectComponent,
    SdvorTimeSlotGroupsTabComponent,
    SdvorTimeSlotGroupsInfoComponent,
    TimeSlotsMinimalPrice,
    NextNHours,
  ],
  exports: [SdvorTimeSlotListComponent],
})
export class SdvorTimeSlotModule {}
